import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import FootBar from "../components/FootBar";
import Spinner from "../components/Spinner";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaStar, FaTiktok, FaYoutube } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6"

const About = () => {
    const [imagesLoaded, setImagesLoaded] = useState(false);
    let ACCOUNTS = require("../assets/carr_4.jpg");
    let TRAVEL = require("../assets/carr_3.jpg");
    let TYPEWRITER = require("../assets/carr_2.jpg");
    let LOANS = require("../assets/carr_1.jpg");

    useEffect(() => {
        const img1 = new Image();
        const img2 = new Image();
        const img3 = new Image();
        const img4 = new Image();

        img1.src = ACCOUNTS;
        img2.src = TRAVEL;
        img3.src = TYPEWRITER;
        img4.src = LOANS;

        const handleImageLoad = () => {
            if (img1.complete && img2.complete && img3.complete && img4.complete) {
                setImagesLoaded(true);
            }
        };

        img1.onload = handleImageLoad;
        img2.onload = handleImageLoad;
        img3.onload = handleImageLoad;
        img4.onload = handleImageLoad;
    }, [ACCOUNTS, TRAVEL, TYPEWRITER, LOANS]);

    const [currentIndex, setCurrentIndex] = useState(0);
    
    const achievements = [
        "On 26/05/2021, an NGO under the Agies of National Association of Uniform voluntary Organizations, delivered a lecture on Social Vices. The school received an Academic Excellence award for 2021, and the chairman was appointed National Patron/Member Advisory Council.",
        "Basic 7, 8, and 9 students excelled in the JETS regional competition, securing second and third positions across all six area councils of FCT.",
        "In the Jet National Competition at Hajj camp on 1st and 9th of July 2021, our pupils secured second position among all six area councils in FCT Abuja.",
        "Macmillan award – 1st prize for three consecutive times.",
        "In the ICT Annual Junior Engineer Technical Scientist Zonal Competition on 9th July, 2022, our pupils secured 2nd position. The college section took 1st and 2nd positions, and our student placed 3rd in the final round in FCT Abuja.",
        "Kuje Inter-School competition by UBEB: Primary section secured 2nd, 2nd, and 4th places, while JS1 and JS2 won 1st overall, qualifying for the second stage.",
        "On 12th–15th November 2023, GPPAF won 1st place in the quiz competition organized by ASAN and NIAS among secondary schools in Abuja, FCT."
    ];
    
    // Move to next achievement every 3 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % achievements.length);
        }, 3000);
    
        // Cleanup the interval on unmount
        return () => clearInterval(intervalId);
    }, [achievements.length]);

    if (!imagesLoaded) {
        return <Spinner />;
    }

    return (
        <div className="about h-full">
            <Topbar />
            <Navbar />

            <div className="header text-white px-6 md:px-8 py-10 bg-[url('./assets/carr_2.jpg')] bg-opacity-50 bg-no-repeat bg-center bg-cover space-y-2">
                <div className="text-white bg-black bg-opacity-80 space-y-4 p-6 rounded-md max-w-lg md:max-w-full mx-4 ">
                    <h1 className="text-3xl lg:text-4xl font-bold">About Glory and Praise Prime Academy</h1>
                    <p className="text-xl lg:max-w-full">
                        Welcome to Glory and Praise Prime Academy Foundation Formerly called Glory
                        & Praise Schools Limited. The School Glory and Praise Prime Academy
                        Foundation (GPPAF) is English/French Speaking School founded on 13th
                        September, 1999 to provide educational facilities for the children of those who
                        want a good foundation for their children's education. <br />
                        We are located in Kuje, on the outskirts of Abuja, in the Federal Capital
                        Territory, not too far from the Nnamdi Azikiwe International Airport. The school
                        buildings and grounds now include 20 buildings and recreation/sports
                        facilities, all of which are meticulously maintained. Further expansion of
                        schools infrastructure is however an ongoing process. 
                    </p>
                    <ul className="flex text-white lg:pt-5">
                        <Link to="https://www.facebook.com/share/1CfCnyYDvU/?mibextid=LQQJ4d">
                            <FaFacebook className="text-3xl lg:text-4xl hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://www.instagram.com/gloryandpraise1/profilecard/?igsh=MXRsZDg5dWtiaHhibQ==">
                            <FaInstagram className="text-3xl lg:text-4xl ml-4 lg:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://www.tiktok.com/@gppaf1?_t=8qCvY9MGpxl&_r=1">
                            <FaTiktok className="text-3xl lg:text-4xl ml-4 lg:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://twitter.com/gloryandpraise1">
                            <FaSquareXTwitter className="text-3xl lg:text-4xl ml-4 lg:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://www.youtube.com/channel/UCZqUadHISmghNq1bIkGaFWQ">
                            <FaYoutube className="text-3xl lg:text-4xl ml-4 lg:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                    </ul>
                </div>
            </div>
            <div className="body text-left font-medium space-y-4 px-6 lg:px-24 py-8">
                <h1 className="text-2xl text-yellow-600 lg:text-3xl font-semibold">About Us </h1>
                <p className="text-xl lg:max-w-full">
                    GPPAF is a co-educational school and presently consists of the
                    Kindergarten/Nursery and Primary School, the Junior Secondary School and
                    the Senior Secondary School, with Boarding Facilities.
                    The Kindergarten/Nursery and Primary School Section of the Glory & Praise
                    Prime Academy Foundation was established on 13 September, 1999, starting
                    with one pupil and three teaching staff at the inception and one non -teaching
                    staff.
                    The first set of primary six graduated in July 2000. With hundred percent pass
                    in Common Entrance Examination into Federal Unity Schools. The Chairman
                    of the school is Amb (Dr.) M.B Oladeji while the proprietress is Mrs. T.F Oladeji
                    .
                    Glory & Praise Prime Academy Foundation (College) was established on 24th
                    October, 2005. The people that conceptualized the establishment of the College
                    were Mr. S.O Adeniji and Michael Ovada the Head Teacher and Music Teacher
                    of Glory and Praise Prime Academy Foundation respectively. The Chairman of
                    Glory & Parise Prime Academy Foundation is Amb. Dr. M.B Oladeji (PhD, FCAI,
                    FNAPPS, NIHIA, IFAA) and the Proprietress is Mrs. Temilola F. Oladeji
                    We are able to maintain the standard of the school with the help of qualified
                    teachers and season administration coupled with functional Laboratories and
                    computer room. There is also a multipurpose hall. Boys and girls hostels have
                    also been built for the ever increasing boarding students. The school also has
                    sport facilities to make teaching and learning conducive.
                    More importantly, some of our students has graduated from Ghana, South
                    Africa, US, UK, Ukraine, Cyprus etc.
                </p>
                <p className="text-xl lg:max-w-full">
                    Glory & Praise received several awards in many external competitions
                    organized by both government and private entities. The best student in
                    creativity and academics from Capital Science Academy, Kuje among others.
                    We are committed to overall student development. That means we want our
                    students to grow through social, recreational, academic and leadership
                    opportunities of every sort. Our students are actively involved in many service
                    learning and co-curricular activities with supervision and guidance of teachers,
                    departmental staff and advisors.
                    When students graduate or move on from GPPAF, they will leave with more
                    than a certificate or transcript. With them goes a lifetime of memories and
                    friendships they'll never forget and a total learning experience that will
                    significantly shape them to be productive and self-reliant for the rest of their
                    lives.
                    Since its founding more than twenty-five (25) years ago, The fundamental
                    mission policy of the school has been to provide the child with the unique
                    education that brings out the best in him/her intellectually, emotionally,
                    physically, morally and indeed spiritually.
                </p>
            </div>
            <div className="body text-left space-y-2 px-6 lg:px-24 py-8">
                <h1 className="text-2xl text-yellow-600 lg:text-3xl font-semibold">Aims And Objective</h1>
                <p className="text-lg text-justify lg:text-xl lg:text-left text-gray-700 font-medium py-2 px-2">
                The aims and objective are as follows:
                </p>
                <ol className="list-decimal list-inside space-y-4 text-lg text-gray-700 font-medium">
                    <li>
                        Its aim is to provide a sound educational background for children of different nationalities in order to serve God and humanity.
                    </li>
                    <li>
                        Glory and Praise Prime Academy Foundation (GPPAF) is established to foster the educational aspirations of the Nigerian people in raising responsible, decent, and academically excellent youths.
                    </li>
                    <li>
                        The school has the primary objective of providing qualitative education and instilling self-actualization, integrity, and discipline in our children. Glory and Praise Prime Academy Foundation (GPPAF) guarantees a conducive, safe, and attractive learning environment for children. Most of the ex-pupils are in leading secondary schools all over Nigeria and other countries.
                    </li>
                    <li>
                        Holistic Student Development.
                    </li>
                </ol>

            </div>

            <div className="body text-left space-y-2 px-6 lg:px-24 py-8">
                <h1 className="text-2xl text-yellow-600 lg:text-3xl font-semibold">Our Achievements</h1>
                <p className="text-lg text-justify lg:text-xl lg:text-left text-gray-700 font-medium py-2 px-2">
                    Glory & Praise pupils won the Macmillan Prize Award three times
                    consecutively. Every year our pupils are admitted into gifted schools. because
                    of their outstanding performance in Entrance Examinations.
                    Glory & Praise Prime Academy Foundation always have the best Common
                    Entrance Examination result in whole Kuje Local Area Council.
                </p>
                <div className="bg-gray-100 p-4 rounded-lg border-2 border-yellow-500 shadow-md">
                    <div className="flex items-start  md:min-h-24">
                        <p className=" mt-2 mr-2"><FaStar className="text-lg md:text-xl text-yellow-500" /></p>
                        
                        <p className="md:text-xl font-medium text-gray-700 text-lg">{achievements[currentIndex]}</p>
                    </div>
                </div>
                <div className="flex justify-center mt-4">
                    <button
                    onClick={() => setCurrentIndex((prevIndex) => (prevIndex - 1 + achievements.length) % achievements.length)}
                    className="bg-gray-700 text-white p-2 rounded-full mr-2"
                    >
                        Prev
                    </button>
                    <button
                    onClick={() => setCurrentIndex((prevIndex) => (prevIndex + 1) % achievements.length)}
                    className="bg-gray-700 text-white p-2 rounded-full"
                    >
                        Next
                    </button>
                </div>
            </div>

            <div className="body text-center space-y-2 px-6 lg:px-48 py-8">
                <h1 className="text-2xl lg:text-3xl font-semibold">Join a School with a Legacy of Excellence</h1>
                <p className="text-lg lg:text-xl text-gray-700 font-medium py-2 px-2">
                    At GPPAF, we believe in not only academic excellence but also in moral and spiritual growth. Our unique approach ensures students are well-prepared to face the challenges of tomorrow's world.
                </p>
            </div>
            <div className="body text-center space-y-2 px-6 lg:px-48 py-8">
                <Link to="/chairman-profile"><button className="bg-yellow-500 text-white px-6 py-4 text-xl font-medium md:text-2xl rounded-md hover:bg-yellow-700">OUR CHAIRMAN'S PROFILE</button></Link>
            </div>

            <FootBar />
        </div>
    );
}

export default About;
